<div [hidden]="consulta">
  <div class="row">
      <div class="col-lg-12" style="padding: 0px;">
          <section class="widget">
              <!-- título -->
              <header>
                  <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
              </header>
          </section>

          <div class="divisor8"></div>

          <section  class="widget">
            <div *ngIf="accion.accionid == 1">
              <div class="divisor8">
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                  <dropdownCustom [opciones]="listaTipoEncuesta" [valorName]="'tipoencuestaid'" [titulo]="'Seleccionar tipo de encuesta'"
                  [displayValor]="'nombre'" [(ngModel)]="tipoEncuesta" (ngModelChange)="cargardatos()"></dropdownCustom>
                </div>
              </div>
              <div *ngIf="tipoEncuesta == 1 || tipoEncuesta == 3" class="row">
                <div *ngIf="tipoEncuesta == 1" class="col-lg-4 col-md-6 col-sm-12 col-12">
                  <inputCustom [titulo]="'Titulo de la encuesta'"
                  [(ngModel)]="entidad.name"></inputCustom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                  <inputCustom [titulo]="'Nombre del documento'"
                  [(ngModel)]="entidad.titulodeldocumento"></inputCustom>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                  <dropdownCustom [opciones]="SelCiclo" [valorName]="'cicloid'" [titulo]="'Ciclo'"
                  [displayValor]="'nombre'" [(ngModel)]="entidad.cicloid"></dropdownCustom>
                </div>
              </div>

            </div>
            <div *ngIf="accion.accionid == 2">
              <div class="divisor8"></div>
              <div class="row">
                  <button class="btn boton botonXS" (click)="verresultados()" > ver resultados</button>
              </div>
            </div>
            <div class="divisor20"></div>
            <div *ngIf="tipoEncuesta == 1 || accion.accionid == 2" class="row margen">
                <div class="col-12">
                    <div class="panelBotonesFiltro">
                        <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                        (click)="Salir()">
                        <span> {{'Cancelar'}}</span>
                    </button>
                    <div class="divisorH16 "></div>
                    <button (click)="Guardar()" class="boton botonSM filled" *ngIf="sistemaService.permisos.agregar && accion.accionid == 1">
                      <span> {{'Crear y abrir en Forms'}}</span>
                    </button>
                    </div>
                </div>
            </div>
            <div *ngIf="!tipoEncuesta" class="row margen">
              <div class="col-12">
                <div class="panelBotonesFiltro">
                    <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                    (click)="Salir()">
                    <span> {{'Cancelar'}}</span>
                </button>
                </div>
            </div>
            </div>
          </section>
          <div class="divisor8"></div>
          <section *ngIf="tipoEncuesta == 2 || tipoEncuesta == 3" class="widget">
            <div class="row">
              <div class="col-12">
                <div class="grupo-form">
                  <ng-container *ngFor="let data of datatable; let i = index">
                    <div class="panel-encuesta"
                    [ngClass]="{'active': selectedIndex === i}"
                    (click)="selectPanel(i, data)">
                      <div class="row">
                        <div class="col-lg-3 col-md-12 col-sm-12 col-12">
                          <span class="icono fa fa-file-text-o" [ngStyle]="{'color': selectedIndex === i ? 'white' : 'black'}"></span>
                        </div>
                        <div class="col-lg-9 col-md-12 col-sm-12 col-12 p-0 pl-4">
                          <span [ngStyle]="{'color': selectedIndex === i ? 'white' : 'black'}">{{data.name}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="divisor" *ngIf="(i + 1) % 4 === 0"></div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="divisor20"></div>
            <div class="row margen">
                <div class="col-12">
                    <div class="panelBotonesFiltro">
                        <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                        (click)="Salir()">
                        <span> {{'Cancelar'}}</span>
                    </button>
                    <div class="divisorH16 "></div>
                    <button class="boton botonSM filled" *ngIf="sistemaService.permisos.agregar"
                    (click)="Guardar()">
                      <span> {{'Crear y abrir en Forms'}}</span>
                    </button>
                    </div>
                </div>
            </div>
          </section>
      </div>
  </div>
</div>
